/** Copy plain text synchronously (call directly from a click handler when possible). */
export async function copyToClipboard(text: string): Promise<void> {
  if (navigator.clipboard?.writeText) {
    await navigator.clipboard.writeText(text);
    return;
  }
  execCommandCopy(text);
}

/**
 * Copy text produced asynchronously while preserving the user-gesture window.
 * Uses ClipboardItem when available so Firestore/network work can finish after click.
 */
export async function copyToClipboardAsync(getText: () => Promise<string>): Promise<string> {
  const textPromise = getText();

  if (navigator.clipboard?.write && typeof ClipboardItem !== 'undefined') {
    await navigator.clipboard.write([
      new ClipboardItem({
        'text/plain': textPromise.then((text) => new Blob([text], { type: 'text/plain' })),
      }),
    ]);
    return textPromise;
  }

  const text = await textPromise;
  await copyToClipboard(text);
  return text;
}

function execCommandCopy(text: string): void {
  const textarea = document.createElement('textarea');
  textarea.value = text;
  textarea.setAttribute('readonly', '');
  textarea.style.position = 'fixed';
  textarea.style.left = '-9999px';
  document.body.appendChild(textarea);
  textarea.select();
  const ok = document.execCommand('copy');
  document.body.removeChild(textarea);
  if (!ok) {
    throw new Error('execCommand copy failed');
  }
}
